import * as React from 'react';
import { cn } from '../../utils';

const Divider = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ className, children, ...props }, ref) => (
  <div
    ref={ref}
    role="separator"
    className={cn(
      'flex items-center gap-3.5 text-[13px] font-bold uppercase tracking-[1px] text-muted-foreground',
      className,
    )}
    {...props}
  >
    <span className="h-0.5 flex-1 rounded-sm bg-border opacity-[0.12]" />
    {children}
    <span className="h-0.5 flex-1 rounded-sm bg-border opacity-[0.12]" />
  </div>
));
Divider.displayName = 'Divider';

export { Divider };
